Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

// animation 
const animationItems = document.querySelectorAll('.animation-item');
if (animationItems.length > 0) {
    function onEntry(e) {
        e.forEach(e => {
            e.isIntersecting && e.target.classList.add("animation-active")
        }
        )
    }
    let options = {
        threshold: [.5]
    }, observer = new IntersectionObserver(onEntry, options)
    for (let e of animationItems)
        observer.observe(e);
}
// end animation

let scrollWidthFunc = () => {
    let scrollWidth = window.innerWidth - document.body.clientWidth;
    document.querySelector('html').style.paddingRight = scrollWidth + 'px';
    if (window.innerWidth < 1024) {
        document.querySelector('header').style.paddingRight = scrollWidth + 'px';
    }
}


// scroll top
const scrollTop = document.querySelector('.scroll-top');
if (scrollTop) {
    function toggleScrollButton() {
        if (window.pageYOffset > 300) {
            scrollTop.classList.remove('hidden');
        } else {
            scrollTop.classList.add('hidden');
        }
    }
    toggleScrollButton();
    window.addEventListener('scroll', toggleScrollButton);
    
    scrollTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}


const scrollLinks = document.querySelectorAll('.scroll-link');
if (scrollLinks.length > 0) {
    scrollLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                const offsetTop = targetElement.offsetTop - 100; 
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
}

/* hide header */
// ['load', 'resize'].forEach((event) => {
//     window.addEventListener(event, function () {
//         let headerHeight = header.clientHeight;
//         const plashka = header.querySelector('.header__plashka');
//         const headerTop = header.querySelector('.header__top');
//         if (plashka) {
//             var originalHeightPlashka = plashka.offsetHeight;
//             var originalHeightHeaderTop = headerTop.offsetHeight;
//         }
//         window.onscroll = function (e) {
//             if (window.scrollY > headerHeight) {
//                 if (!plashka.classList.contains('hide')) {
//                     plashka.classList.add('hide');
//                     plashka.style.height = '0px';
//                     plashka.style.opacity = '0';
//                     plashka.style.overflow = 'hidden';

//                     if(window.innerWidth > 1260) {
//                         headerTop.classList.add('hide');
//                         headerTop.style.height = '0px';
//                         headerTop.style.opacity = '0';
//                         headerTop.style.overflow = 'hidden';
//                     }
//                 }
//             }
//             else {
//                 plashka.style.height = originalHeightPlashka + 'px';
//                 plashka.classList.remove('hide');
//                 plashka.style.opacity = '1';

//                 headerTop.style.height = originalHeightHeaderTop + 'px';
//                 headerTop.classList.remove('hide');
//                 headerTop.style.opacity = '1';
//                 headerTop.style.overflow = 'visible';
//             }
//         };
//     })
// })
/* hide header */


document.addEventListener("DOMContentLoaded", function () {
    /* burger menu */
    const burger = document.querySelector('.burger');
    if (burger) {
        const headerMobile = document.querySelector('.header__bottom');
        const header = document.querySelector('.header');
        burger.addEventListener("click", () => {
            headerMobile.classList.toggle("active");
            burger.classList.toggle("active");
            header.classList.toggle("active");
            if (burger.classList.contains('active')) {
                scrollWidthFunc();
            }
            else {
                document.querySelector('html').style.paddingRight = '0px';
                document.querySelector('header').style.paddingRight = '0px';
            }
            document.querySelector('html').classList.toggle('burger-lock');
        });
    }
    /* end burger menu */



    // dropdown menu
    const menuBtns = document.querySelectorAll('button.header__nav-open');

    if (menuBtns.length > 0) {
        menuBtns.forEach(function (menuBtn) {
            menuBtn.addEventListener('click', function () {
                if (window.innerWidth > 1024) {
                    menuBtns.forEach(el => {
                        if (el != this) {
                            el.classList.remove('active');
                        }
                    });
                    menuBtn.classList.toggle('active');
                }
            });
            window.addEventListener('click', function (e) {
                if (window.innerWidth > 1024) {
                    const target = e.target;
                    if (!target.closest('.header__nav-open')) {
                        menuBtn.classList.remove('active');
                    }
                }
            });
        });
    }


    // mobile menu
    // const navButtons = document.querySelectorAll(".header__nav-open");

    // navButtons.forEach(btn => {
    //     const sublist = btn.querySelector(".header__nav-sublist");

    //     btn.addEventListener("click", (e) => {
    //         if (window.innerWidth >= 1024) return;
    //         if (sublist.contains(e.target)) return;

    //         // Закрываем все остальные
    //         navButtons.forEach(otherBtn => {
    //             if (otherBtn !== btn) {
    //                 otherBtn.classList.remove("active");
    //                 const otherSublist = otherBtn.querySelector(".header__nav-sublist");
    //                 otherSublist.style.maxHeight = null;
    //             }
    //         });

    //         // Тоглим текущий
    //         btn.classList.toggle("active");

    //         if (btn.classList.contains("active")) {
    //             sublist.style.maxHeight = sublist.scrollHeight + "px";
    //         } else {
    //             sublist.style.maxHeight = null;
    //         }
    //     });
    // });





        const navButtons = document.querySelectorAll(".header__nav-open");
    
        // Функция пересчёта полной высоты (с учётом вложенных списков)
        function getFullHeight(element) {
            let clone = element.cloneNode(true);
            clone.style.maxHeight = "none";
            clone.style.height = "auto";
            clone.style.opacity = "0";
            clone.style.position = "absolute";
            clone.style.pointerEvents = "none";
            document.body.appendChild(clone);
            let height = clone.scrollHeight;
            document.body.removeChild(clone);
            return height;
        }
    
        // Первый уровень аккордеона
        navButtons.forEach(btn => {
            const sublist = btn.querySelector(".header__nav-sublist");
    
            btn.addEventListener("click", (e) => {
                if (window.innerWidth >= 1024) return;
    
                if (e.target.closest(".header__nav-arrow")) return;
                if (sublist.contains(e.target)) return;
    
                // закрыть другие
                // navButtons.forEach(otherBtn => {
                //     if (otherBtn !== btn) {
                //         otherBtn.classList.remove("active");
                //         const otherSublist = otherBtn.querySelector(".header__nav-sublist");
                //         otherSublist.style.maxHeight = null;
                //     }
                // });
    
                btn.classList.toggle("active");
    
                if (btn.classList.contains("active")) {
                    sublist.style.maxHeight = getFullHeight(sublist) + "px";
                } else {
                    sublist.style.maxHeight = null;
                }
            });
    
            // Второй уровень аккордеона
            const arrows = sublist.querySelectorAll(".header__nav-arrow");
            arrows.forEach(arrow => {
                const link = arrow.previousElementSibling;
                const subsublist = arrow.nextElementSibling;
    
                arrow.addEventListener("click", (e) => {
                    e.stopPropagation();
                    arrow.classList.toggle("active");
                    link.classList.toggle("active");
    
                    if (arrow.classList.contains("active")) {
                        subsublist.style.maxHeight = subsublist.scrollHeight + "px";
                    } else {
                        subsublist.style.maxHeight = null;
                    }
    
                    // пересчитать высоту родителя с учётом всех элементов
                    sublist.style.maxHeight = getFullHeight(sublist) + "px";
                });
            });
        });

    

    
    // end mobile menu

    



    // Popups
    function popupClose(popupActive) {
        popupActive.classList.remove('open');
        setTimeout(() => {
            if (!popupActive.classList.contains('open')) {
                popupActive.classList.remove('active');
            }
        }, 400);
        document.body.classList.remove('lock');
        document.querySelector('html').style.paddingRight = 0;
        document.querySelector('html').classList.remove('lock');
        document.querySelector('header').removeAttribute('style');


    }
    const popupOpenBtns = document.querySelectorAll('.popup-btn');
    const popups = document.querySelectorAll('.popup');
    const originalTitlePopup2 = document.querySelector('.original-title').innerHTML;
    const closePopupBtns = document.querySelectorAll('.close-popup-btn');
    closePopupBtns.forEach(function (el) {
        el.addEventListener('click', function (e) {
            popupClose(e.target.closest('.popup'));
        });
    });
    popupOpenBtns.forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            const path = e.currentTarget.dataset.path;
            const currentPopup = document.querySelector(`[data-target="${path}"]`);
            if (currentPopup) {
                popups.forEach(function (popup) {
                    popupClose(popup);
                    popup.addEventListener('click', function (e) {
                        if (!e.target.closest('.popup__content')) {
                            popupClose(e.target.closest('.popup'));
                        }
                    });
                });
                currentPopup.classList.add('active');
                setTimeout(() => {
                    currentPopup.classList.add('open');
                }, 10);
                if (currentPopup.getAttribute('data-target') == 'popup-change') {

                    let originaTitle = currentPopup.querySelector('.original-title');
                    if (el.classList.contains('change-item__btn')) {

                        if (el.classList.contains('doctor__btn-js')) {
                            let currentItem = el.closest('.change-item');
                            let currentTitile = currentItem.querySelector('.change-item__title');
                            originaTitle.innerHTML = 'Записаться на приём к врачу: ' + currentTitile.innerHTML
                        }
                        else {
                            if (el.classList.contains('change-item__btn_current')) {
                                originaTitle.textContent = el.textContent;
                            }
                            else {
                                let currentItem = el.closest('.change-item');
                                let currentTitile = currentItem.querySelector('.change-item__title');
                                originaTitle.innerHTML = currentTitile.innerHTML
                            }
                        }
                    }
                    else {
                        originaTitle.innerHTML = originalTitlePopup2;
                    }
                }

                if (currentPopup.getAttribute('data-target') == 'popup-jobs') {
                    let currentItems = el.closest('.jobs__items') 
                    let originalText = currentPopup.querySelector('.jobs__inner_original');
                    if(originalText && currentItems.querySelector('.jobs__inner')) {
                        originalText.innerHTML = currentItems.querySelector('.jobs__inner').innerHTML;
                    }
                }
                e.stopPropagation();
                scrollWidthFunc();
                document.querySelector('html').classList.add('lock');
            }
        });
    });
    // end popups



    /* yandex map */
    const mapPlaceholder = document.getElementById('map-placeholder');
    if (mapPlaceholder) {
        mapPlaceholder.addEventListener('mouseenter', loadMap, { once: true });
        mapPlaceholder.addEventListener('click', loadMap, { once: true });
    } else {
        loadMap();
    }

    function loadMap() {
        if (!document.querySelector('[src="https://api-maps.yandex.ru/2.1/?lang=ru_RU"]')) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
            script.onload = initMap;
            document.head.appendChild(script);
        } else {
            initMap();
        }
    }
    
    function initMap() {
        const mapPlaceholder = document.getElementById('map-placeholder');
        if (mapPlaceholder) {
            mapPlaceholder.remove();
        }
    
        ymaps.ready(function () {
            const myMap = new ymaps.Map('map', {
                center: [47.231129, 39.728721],
                zoom: 13,
                controls: []
            });
    
            const myPlacemark = new ymaps.Placemark(
                [47.231129, 39.728721],
                {
                    hintContent: 'Ростов-на-Дону, ул. Красноармейская, д. 227',
                    balloonContent: 'Ростов-на-Дону, ул. Красноармейская, д. 227'
                },
                {
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/img/icons/map-pin.png',  //заменить на свою иконку
                    iconImageSize: [21, 26],
                    iconImageOffset: [-15, -31],
                }
            );
    
            myMap.geoObjects.add(myPlacemark);
            myMap.behaviors.disable(['scrollZoom']);
        });
    }
    /* end yandex map */


    // close cookie 
	const cookieBtn = document.querySelector('.popup-cookie__btn')
    if (cookieBtn) {
        cookieBtn.addEventListener('click', () => {
            document.querySelector('.popup-cookie').style.display = 'none';
        })
    }


    /*  search */
	const inputSearch = document.querySelectorAll('input[type=search]')
	if (inputSearch.length > 0) {
		inputSearch.forEach(elem => {
			const wrapper = elem.closest('.search-wrapper')
			if (wrapper) {
				const searchResultBlock = wrapper.querySelector('.popup__search-result')
				const popularCitiesBlock = wrapper.querySelector('.popup__search')
				const noResultsMessage = searchResultBlock.querySelector('.no-results-message')

				function search() {
					let filter = elem.value.toUpperCase()
					let ul = wrapper.querySelectorAll('.search-list')
					let totalResults = 0

					ul.forEach(item => {
						let li = item.getElementsByTagName('li')
						for (let i = 0; i < li.length; i++) {
							let a = li[i].querySelector('.search-name')
							if (a.innerHTML.toUpperCase().indexOf(filter) > -1) {
								li[i].classList.remove('none')
								totalResults++
							} else {
								li[i].classList.add('none')
							}
						}
					})
                    noResultsMessage.classList.toggle('none', totalResults > 0);

					if (elem.value.trim() === '') {
						searchResultBlock.classList.add('none')
						popularCitiesBlock.classList.remove('none')
					} else {
						searchResultBlock.classList.remove('none')
						popularCitiesBlock.classList.add('none')
					}
				}
				elem.addEventListener('input', search)

                document.addEventListener('click', (event) => {
                    if (!wrapper.contains(event.target)) {
                        searchResultBlock.classList.add('none')
                    }
                })
			}
		})
	}
    /*  end search  */  


    /*  accordion  */
	const acc = document.getElementsByClassName('accordion')
	for (let i = 0; i < acc.length; i++) {
        if(acc[i]) {
            acc[i].addEventListener('click', function () {
                const accContent = this.querySelector('.accordion__content')  || this.parentElement.querySelector('.accordion__content') 
                if (accContent.classList.contains('accordion__content--active')) {
                    accContent.classList.remove('accordion__content--active');
                    this.classList.remove('accordion--active');
                    accContent.style.maxHeight = '0'; 
                } else {
                    accContent.classList.add('accordion__content--active');
                    this.classList.add('accordion--active');
    
                    const contentHeight = accContent.scrollHeight;
                    accContent.style.maxHeight = `${contentHeight}px`;
                }
            })
        }
	}
	/*  end accordion   */


    /*  tab  */
	const showTab = elTabBtn => {
		const elTab = elTabBtn.closest('.tab');
		if (elTabBtn.classList.contains('tab-btn--active')) {
			return;
		}
		const targetId = elTabBtn.dataset.id;
		const elTabPanes = elTab.querySelectorAll(`.tab-content[data-id="${targetId}"]`);

		const elTabBtnActive = elTab.querySelector('.tab-btn--active');
		if (elTabBtnActive) {
			elTabBtnActive.classList.remove('tab-btn--active');
		}

		const elTabPaneShow = elTab.querySelectorAll('.tab-content--active');
		elTabPaneShow.forEach(pane => pane.classList.remove('tab-content--active'));

		elTabBtn.classList.add('tab-btn--active');
		elTabPanes.forEach(pane => pane.classList.add('tab-content--active'));
	};

    const tabButtons = document.querySelectorAll('.tab-btn')
	tabButtons.forEach(btn => {
        if(btn) {
            btn.addEventListener('click', function (e) {
                showTab(this);
                quantityElem();
            });            
        }
	});
	/*  end tab */


    // quantity-card
    function quantityElem() {
        const quantityCards = document.querySelectorAll('.quantity-card');
        const quantityElement = document.querySelector('.quantity span');
        if (quantityElement) {
            let visibleCards = 0;
            quantityCards.forEach(card => {
                if (card.offsetParent !== null) {
                    visibleCards++;
                }
            });
            quantityElement.textContent = visibleCards;
        }
    }
    setTimeout(quantityElem, 100);


    /* search in page */
    const searchInput = document.getElementById('searchInput')
    if (searchInput) {
        searchInput.addEventListener('input', function () {
            const searchValue = this.value.toLowerCase();
            const rows = document.querySelectorAll('.search-page-item'); 
        
            rows.forEach(function (row) {
                const serviceName = row.querySelector('.search-page-name').textContent.toLowerCase();
        
                if (serviceName.includes(searchValue)) {
                    row.style.display = '';
                } else {
                    row.style.display = 'none';
                }
            });
            quantityElem();
            checkAndHideBlocksIfEmpty();
        });
    }


    /*  btn more  */
    const moreBtns = document.querySelectorAll('.btn-more');
    moreBtns.forEach(moreBtn => {
        if (moreBtn) {
            const moreContent = moreBtn.previousElementSibling;

            if (moreContent.scrollHeight <= moreContent.clientHeight) {
                moreBtn.style.display = 'none'; 
            } else {
                const textBtn = moreBtn.innerHTML; 
                moreBtn.addEventListener('click', function() {
                    const heightMoreContent = moreContent.style.maxHeight; 
                    this.classList.toggle('active');

                    if (moreContent.style.maxHeight) {
                        moreContent.style.maxHeight = null;
                        this.textContent = textBtn;
                    } else {
                        moreContent.style.maxHeight = moreContent.scrollHeight + "px"; 
                        this.textContent = 'Свернуть';
                    }
                });
            }
        }
    });
    /*  end btn more  */


    // кнопка Показать еще
    function showAllButtons() {
        const allButtons = document.querySelectorAll('.show-btn');

        allButtons.forEach(button => {
            const parentBlock = button.closest('.show-block');
            const items = parentBlock.querySelectorAll('.show-item');

            const defaultItemsCount = parseInt(button.dataset.showCount) || 8;
    
            const textShow = button.innerHTML;
            const textHide = 'Скрыть';
            
            // Проверяем количество элементов
            if (items.length <= defaultItemsCount) {
                button.style.display = 'none';
            } else {
                button.style.display = 'block';
                button.textContent = textShow;
                
                // Скрываем элементы
                items.forEach((item, index) => {
                    if (index >= defaultItemsCount) {
                        item.style.display = 'none';
                    }
                });

                // Обработчик клика по кнопке
                button.addEventListener('click', function() {
                    if (button.textContent == textHide) {
                        // Скрываем элементы
                        items.forEach((item, index) => {
                            if (index >= defaultItemsCount) {
                                item.style.display = 'none';
                            }
                        });
                        button.textContent = textShow;
                    } else {
                        // Показываем все элементы
                        items.forEach(item => {
                            item.style.display = '';
                        });
                        button.textContent = textHide;
                    }
                });
            }
        });
    }
    showAllButtons();
    // end кнопка Показать еще



    /* navigation */
    
    const articleNavigation = document.querySelector(".navigation");
    if (articleNavigation) {
        const jsScrollBlockList = document.querySelectorAll(
            ".text-block h1, .text-block h2, .text-block h3, .text-block h4"
        );
    
        if (jsScrollBlockList.length > 0) {
            for (let i = 0; i < jsScrollBlockList.length; i += 1) {
                const jsScrollBlock = jsScrollBlockList[i];
                const titleBlock = jsScrollBlock.textContent;
                const articleNavigationList =
                    document.querySelector(".navigation__list");
                const articleNavigationItem = document.createElement("li");
                const articleNavigationLink = document.createElement("a");
                if (jsScrollBlock.tagName == "H1") {
                    articleNavigationItem.classList.add("nav-title-h1");
                }
                articleNavigationItem.classList.add("navigation__item");
                if (jsScrollBlock.tagName == "H2") {
                    articleNavigationItem.classList.add("nav-title-h2");
                } else if (jsScrollBlock.tagName == "H3") {
                    articleNavigationItem.classList.add("nav-title-h3");
                } else if (jsScrollBlock.tagName == "H4") {
                    articleNavigationItem.classList.add("nav-title-h4");
                } else if (jsScrollBlock.tagName == "H5") {
                    articleNavigationItem.classList.add("nav-title-h5");
                } else if (jsScrollBlock.tagName == "H6") {
                    articleNavigationItem.classList.add("nav-title-h6");
                }
                articleNavigationLink.classList.add("navigation__link");
                jsScrollBlock.setAttribute("id", `${i}`);
                articleNavigationLink.setAttribute("href", `$${i}`);
                articleNavigationLink.textContent = " " + titleBlock;
                articleNavigationItem.append(articleNavigationLink);
                articleNavigationList.append(articleNavigationItem);
            }
            document.querySelectorAll('a[href^="$"').forEach((link) => {
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    let href = this.getAttribute("href").substring(1);
                    const scrollTarget = document.getElementById(href);
                    const topOffset = 100;
                    const elementPosition = scrollTarget.getBoundingClientRect().top;
                    const offsetPosition = elementPosition - topOffset;
                    window.scrollBy({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                });
            });
        } else {
            if(articleNavigation.querySelector(".navigation")) {
                articleNavigation.querySelector(".navigation").remove();
            }
        }
    }
    /* end navigation */



})

// document.addEventListener('DOMContentLoaded', () => {
//     const headers = document.querySelectorAll('.nav-title-h2');

//     headers.forEach((item, index) => {
//         if (item.closest('.navigation-4')) {
//             return;
//         }

//         let nextElement = item.nextElementSibling;
//         const isFirstHeader = index === 0;

//         if (isFirstHeader) {
//             item.classList.add('active');
//         }

//         while (nextElement && !nextElement.classList.contains('nav-title-h2')) {
//             nextElement.style.display = isFirstHeader ? 'block' : 'none';
//             nextElement = nextElement.nextElementSibling;
//         }

//         item.addEventListener('click', () => {
//             let nextElement = item.nextElementSibling;
//             const isActive = item.classList.toggle('active');

//             while (nextElement && !nextElement.classList.contains('nav-title-h2')) {
//                 nextElement.style.display = isActive ? 'block' : 'none';
//                 nextElement = nextElement.nextElementSibling;
//             }
//         });
//     });
// });

